/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import SignupEmailForm from './SignupEmailForm';
import SignupAuthenticationHelper from 'src/shared/app/signup/component/authentication/base/SignupAuthenticationHelper';
import messages from 'src/shared/app/signup/l10n/emailSignupL10n';
import styles from 'src/shared/app/authentication/component/base/AuthenticationBase.style';
import LazyLoginMain from 'src/shared/app/authentication/component/login/LazyLoginMain';
import ZIndexTopBar from 'src/shared/app/base/component/template/component/TopBar';
import TopBar from 'src/shared/app/nav/component/top-bar/TopBar';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import { loginRoute } from 'src/shared/app/base/route/setting/routeSettings';

type Props = {
  handleSubmit: (Object) => Promise<any>,
};

const useStyles = createUseStyles(styles);

const SignupEmailSection = ({ handleSubmit }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();
  const [loginPath] = useRoutes(loginRoute);

  /*
   |----------------------------------------------------------------------------
   | Effects
   |----------------------------------------------------------------------------
   */

  React.useEffect(() => {
    LazyLoginMain.preload();
  }, []);

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <section className={classes.section}>
      <ZIndexTopBar>
        <TopBar
          title={intl.formatMessage(messages.heading)}
          actionLabel={intl.formatMessage(messages.login)}
          actionRoute={loginPath}
        />
      </ZIndexTopBar>
      <SignupEmailForm handleSubmit={handleSubmit} />
      <SignupAuthenticationHelper />
    </section>
  );
};

export default compose(React.memo)(SignupEmailSection);
